// enquiry-module-v1/MasterPages/ActivityMaster.jsx

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
    Box,
    Paper,
    Typography,
    TextField,
    Grid,
    Button,
} from '@mui/material';

export default function ActivityMaster({
    mode,
    onPopupCancel,
    loggedInUser,
    companyData
}) {
    const { id } = useParams();
    const navigate = useNavigate();

    // Use props instead of context
    const companyId = companyData?.companyId;
    const fYear = companyData?.financialYear;
    const username = loggedInUser?.emailId;

    const [activityName, setActivityName] = useState('');

    // Load existing data when in edit mode
    useEffect(() => {
        if (mode === 'edit' && id) {
            axios
                .get(`http://192.168.1.248:3004/activity/getDetails/${id}`)
                .then(res => setActivityName(res.data.Activity || ''))
                .catch(err => console.error('Error fetching activity:', err));
        }
    }, [mode, id]);

    const handleCancel = () => {
        if (onPopupCancel) {
            onPopupCancel();
        } else {
            navigate('/main/activityDetail');
        }
    };

    const handleSubmit = async e => {
        e.preventDefault();
        const payload = { Activity: activityName, companyId, fYear, username };

        try {
            if (mode === 'add') {
                await axios.post(
                    'http://192.168.1.248:3004/activity/Insert',
                    payload
                );
                alert('Activity added successfully');
                setActivityName('');
            } else {
                await axios.put(
                    `http://192.168.1.248:3004/activity/Update/${id}`,
                    payload
                );
                alert('Activity updated successfully');
            }
            handleCancel();
        } catch (err) {
            console.error('Error saving activity:', err);
            alert(`Failed to ${mode === 'add' ? 'add' : 'update'} activity`);
        }
    };

    return (
        <Paper elevation={3} sx={{ maxWidth: 600, mx: 'auto', p: 4 }}>
            <Typography variant="h5" gutterBottom>
                {mode === 'add' ? 'Add New Activity' : 'Edit Activity'}
            </Typography>

            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            label="Activity"
                            required
                            fullWidth
                            size="small"
                            value={activityName}
                            onChange={e => setActivityName(e.target.value)}
                        />
                    </Grid>

                    <Grid item xs={12} container justifyContent="center" spacing={2}>
                        <Grid item>
                            <Button type="submit" variant="contained" color="primary">
                                {mode === 'add' ? 'Save' : 'Update'}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="outlined" onClick={handleCancel}>
                                Cancel
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
}